import { HTMLAttributes, useContext, useEffect, useState } from "react";
import { StorageManagerDriver } from "./storage-manager.context";
import { Storage } from "./storage-manager.storage";

export interface IStorageManagerProps extends HTMLAttributes<HTMLElement> {
  memoryType?: "session" | "persist";
  storageKey: string;
}

interface IRecords<TData> {
  [key: string]: TData;
}

const StorageDriver = StorageManagerDriver<IRecords<any>>();

export const useStorage = () => useContext(StorageDriver);

export const StorageManager = <TData,>({ children, memoryType = "persist", storageKey = "STORAGE", ...props }: IStorageManagerProps) => {
  const store = Storage(memoryType);
  const [data, setData] = useState<IRecords<TData> | null>(store.get<IRecords<TData>>(storageKey));

  const setStorage = (key: string, dataValue: TData): void => {
    const chached = {
      ...data,
      [key]: {
        ...(data || {})[key],
        ...dataValue,
      },
    };
    setData(chached);
    store.set(storageKey, chached);
  };

  const getStorage = (key: string): TData => {
    return (data || {})[key];
  };

  const deleteStorage = (key: string): void => {
    const chached = {
      ...data,
    };
    if (chached[key]) {
      delete chached[key];
    }
    store.set(storageKey, chached);
  };

  return <StorageDriver.Provider value={{ setStorage, getStorage, deleteStorage }}>{children}</StorageDriver.Provider>;
};
